import { axiosInstance } from '@/Api/axiosV2Config';

export interface PresaleSheetConfig {
  warrantyUuid: string;
  showPrice: boolean;
  bannerColor: string;
  headerImageUrl: string | null;
  updatedAt: string | null;
}

export interface UpsertPresaleSheetConfigPayload {
  showPrice?: boolean;
  bannerColor?: string;
  headerImageUrl?: string | null;
}

export const presaleSheetApi = {
  generatePdf: async (warrantyUuid: string, showPrice = true, bannerColor?: string, headerImage?: string): Promise<Blob> => {
    const { data } = await axiosInstance.post(
      '/pro-v2/contracts/presale-sheet-preview',
      { warrantyUuid, showPrice, bannerColor, headerImage },
      { responseType: 'blob' },
    );
    return data;
  },
};

export const presaleSheetConfigApi = {
  get: async (warrantyUuid: string): Promise<PresaleSheetConfig> => {
    const { data } = await axiosInstance.get<PresaleSheetConfig>(
      `/pro-v2/presale-sheet-config/${warrantyUuid}`,
    );
    return data;
  },

  upsert: async (
    warrantyUuid: string,
    payload: UpsertPresaleSheetConfigPayload,
  ): Promise<PresaleSheetConfig> => {
    const { data } = await axiosInstance.put<PresaleSheetConfig>(
      `/pro-v2/presale-sheet-config/${warrantyUuid}`,
      payload,
    );
    return data;
  },

  uploadHeaderImage: async (
    warrantyUuid: string,
    file: File,
  ): Promise<PresaleSheetConfig> => {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await axiosInstance.post<PresaleSheetConfig>(
      `/pro-v2/presale-sheet-config/${warrantyUuid}/header-image`,
      formData,
    );
    return data;
  },

  deleteHeaderImage: async (warrantyUuid: string): Promise<PresaleSheetConfig> => {
    const { data } = await axiosInstance.delete<PresaleSheetConfig>(
      `/pro-v2/presale-sheet-config/${warrantyUuid}/header-image`,
    );
    return data;
  },
};
